import { Component, Input, OnInit } from "@angular/core";
import { DotType, Options } from "ngx-qrcode-styling";
import { OptionAdvancedQr, TypeQr } from "./tya-qrcode.data";

@Component({
  selector: "tya-qrcode",
  templateUrl: "./tya-qrcode.component.html",
  styleUrls: ["./tya-qrcode.component.scss"],
})
export class TyaQrcodeComponent implements OnInit {
  @Input() typeQr: string = "Basic";
  @Input() contentQR: string = "No data";
  @Input() width: number = 256;
  @Input() colorQR: string = "#000000ff";
  @Input() colorBackground: string = "#ffffffff";
  @Input() scale: number = 4;
  @Input() margin: number = 4;
  @Input() cssClass: string = "qrcode";
  @Input() urlImage: string = "";
  @Input() typeDots: DotType = "dots";

  isShowDown = false;

  typeQrData = TypeQr;
  optionAdvancedQr = OptionAdvancedQr;
  config: Options = {};

  constructor() {}

  ngOnInit() {
    this.config = {
      width: this.width,
      height: this.width,
      data: this.contentQR,
      image: this.urlImage,
      margin: this.margin,
      dotsOptions: {
        color: this.colorQR,
        type: this.typeDots,
      },
      backgroundOptions: {
        color: this.colorBackground,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 2,
      },
    };
  }

  saveAsImage(UrlQR) {
    const parentElement =
      UrlQR.qrcElement.nativeElement.querySelector("img").src;

    console.log(parentElement);
    let blobData = this.convertBase64ToBlob(parentElement);
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //IE
      window.navigator.msSaveOrOpenBlob(blobData, "Qrcode");
    } else {
      // chrome
      const blob = new Blob([blobData], { type: "image/png" });
      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Qrcode";
      link.click();
    }
  }

  private convertBase64ToBlob(Base64Image: any) {
    const parts = Base64Image.split(";base64,");
    const imageType = parts[0].split(":")[1];
    const decodedData = window.atob(parts[1]);
    const uInt8Array = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: imageType });
  }
}
